import Company from "../../services/Company";
import createModelStore from "../../utils/createModelStore";

const companies = createModelStore<Company.Model, "companies">("companies");

export default companies;
